import type { Config } from './types';

export const Production: Partial<Config> = {
  GEM_HOST: 'https://www.gem.com',
  LAUNCHDARKLY_CLIENT_SIDE_ID: '6361727f68aa4d0bbd76771d',
  LEVER_HOST: 'https://hire.lever.co',
  LEVER_SANDBOX_HOST: 'https://hire.sandbox.lever.co',
  SEGMENT_WRITE_KEY: 'yDvCx5uyMuPyotEOaSvgiIIuVyospQWf',
};
